import React from "react";
import styled from "styled-components";

import Chine from "../../assets/team/Chine.png";
import Rains from "../../assets/team/Rains.png";
import PotatoKing from "../../assets/team/PotatoKing.png";
import Seven from "../../assets/team/Seven.png";
import Emiyns from "../../assets/team/Emiyns.png";
import Boba from "../../assets/team/Boba.png";
import Mingming from "../../assets/team/Mingming.png";
import Kaybu from "../../assets/team/Kaybu.png";
import LK from "../../assets/team/LK.png";
import Picano from "../../assets/team/Picano.png";
import Mido from "../../assets/team/Mido.png";
import JN from "../../assets/team/JN.png";
import Nomad from "../../assets/team/Nomad.png";

// WebP versions
import ChineWebP from "../../assets/webp/team/Chine.webp";
import RainsWebP from "../../assets/webp/team/Rains.webp";
import PotatoKingWebP from "../../assets/webp/team/PotatoKing.webp";
import SevenWebP from "../../assets/webp/team/Seven.webp";
import EmiynsWebP from "../../assets/webp/team/Emiyns.webp";
import BobaWebP from "../../assets/webp/team/Boba.webp";
import MingmingWebP from "../../assets/webp/team/Mingming.webp";
import KaybuWebP from "../../assets/webp/team/Kaybu.webp";
import LKWebP from "../../assets/webp/team/LK.webp";
import PicanoWebP from "../../assets/webp/team/Picano.webp";
import MidoWebP from "../../assets/webp/team/Mido.webp";
import JNWebP from "../../assets/webp/team/JN.webp";
import NomadWebP from "../../assets/webp/team/Nomad.webp";

import Loading from "../Loading";
import OptimizedImage from "../OptimizedImage";

const Section = styled.section`
  min-height: 100vh;
  width: 100vw;
  background-color: ${(props) => props.theme.body};
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(
        135deg,
        rgba(130, 109, 251, 0.1) 0%,
        rgba(159, 122, 234, 0.07) 20%,
        rgba(255, 255, 255, 0.04) 40%,
        rgba(130, 109, 251, 0.06) 60%,
        rgba(159, 122, 234, 0.08) 80%,
        rgba(130, 109, 251, 0.12) 100%
      ),
      linear-gradient(
        45deg,
        rgba(159, 122, 234, 0.05) 0%,
        transparent 30%,
        rgba(130, 109, 251, 0.06) 70%,
        transparent 100%
      );
    z-index: 1;
    pointer-events: none;
  }

  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: radial-gradient(
        ellipse 1200px 900px at 15% 20%,
        rgba(130, 109, 251, 0.12) 0%,
        rgba(159, 122, 234, 0.07) 30%,
        transparent 70%
      ),
      radial-gradient(
        ellipse 900px 1200px at 85% 80%,
        rgba(159, 122, 234, 0.1) 0%,
        rgba(130, 109, 251, 0.05) 35%,
        transparent 75%
      ),
      radial-gradient(
        ellipse 800px 600px at 50% 10%,
        rgba(255, 255, 255, 0.05) 0%,
        transparent 60%
      ),
      radial-gradient(
        ellipse 600px 400px at 20% 90%,
        rgba(130, 109, 251, 0.07) 0%,
        transparent 80%
      ),
      radial-gradient(
        ellipse 500px 700px at 70% 30%,
        rgba(159, 122, 234, 0.05) 0%,
        transparent 85%
      );
    z-index: 1;
    pointer-events: none;
  }
`;
const Title = styled.h1`
  font-size: ${(props) => props.theme.fontxxl};
  text-transform: capitalize;
  color: ${(props) => props.theme.text};
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 1rem auto;
  border-bottom: 2px solid ${(props) => props.theme.text};
  width: fit-content;
  position: relative;
  z-index: 2;

  @media (max-width: 40em) {
    font-size: ${(props) => props.theme.fontxl};
  }
`;

const Container = styled.div`
  width: 75%;
  margin: 2rem auto;
  position: relative;
  z-index: 2;

  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;

  @media (max-width: 64em) {
    width: 80%;
  }
  @media (max-width: 48em) {
    width: 90%;
    justify-content: center;
  }
`;

const Item = styled.div`
  width: calc(20rem - 4vw);
  padding: 1rem 0;
  color: ${(props) => props.theme.body};
  margin: 2rem 1rem;
  position: relative;
  z-index: 5;

  backdrop-filter: blur(4px);

  border: 2px solid ${(props) => props.theme.text};
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    transform: scale(1.05);
    img {
      transform: translateY(-2rem) scale(1.2);
    }
  }

  @media (max-width: 30em) {
    width: 70vw;
  }
`;

const ImageContainer = styled.div`
  width: 80%;
  margin: 0 auto;
  background-color: ${(props) => props.theme.carouselColor};
  border: 1px solid ${(props) => props.theme.text};
  padding: 1rem;

  border-radius: 20px;
  cursor: pointer;

  img {
    width: 100%;
    height: auto;
    transition: all 0.3s ease;
  }
`;

const Name = styled.h2`
  font-size: ${(props) => props.theme.fontlg};
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  color: ${(props) => props.theme.text};
  margin-top: 1rem;
`;

const Position = styled.h2`
  font-size: ${(props) => props.theme.fontmd};
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: capitalize;
  color: ${(props) => `rgba(${props.theme.textRgba},0.9)`};
  font-weight: 400;
`;

const MemberComponent = ({
  img,
  webpImg,
  name = " ",
  position = " ",
  twitterLink = "#",
}) => {
  const handleClick = () => {
    if (twitterLink && twitterLink !== "#") {
      window.open(twitterLink, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <Item onClick={handleClick}>
      <ImageContainer>
        <OptimizedImage
          src={img}
          webpSrc={webpImg}
          alt={name}
          width={500}
          height={400}
          loading="lazy"
          placeholder={`Loading ${name}...`}
          errorText={`Failed to load ${name}'s image`}
          borderRadius="15px"
        />
      </ImageContainer>
      <Name>{name}</Name>
      <Position>{position}</Position>
    </Item>
  );
};

const Team = () => {
  return (
    <Section id="team">
      <Title>Team</Title>
      <Container>
        <MemberComponent
          img={Chine}
          webpImg={ChineWebP}
          name="Chine"
          position="Founder"
          twitterLink="https://x.com/0xChine"
        />
        <MemberComponent
          img={Rains}
          webpImg={RainsWebP}
          name="Rains"
          position="Co-Founder & Lead artist"
          twitterLink="https://x.com/rainss08"
        />
        <MemberComponent
          img={PotatoKing}
          webpImg={PotatoKingWebP}
          name="Potato King"
          position="Co-Founder & Artist"
          twitterLink="https://x.com/0xpotatoking"
        />
        <MemberComponent
          img={Seven}
          webpImg={SevenWebP}
          name="Seven"
          position="Co-Founder & Dev"
          twitterLink="https://x.com/_Seven7777777"
        />
        <MemberComponent
          img={Boba}
          webpImg={BobaWebP}
          name="Boba"
          position="Community lead"
          twitterLink="https://x.com/0xbobaa"
        />
        <MemberComponent
          img={Emiyns}
          webpImg={EmiynsWebP}
          name="Emiyns"
          position="Collab manager"
          twitterLink="https://x.com/emiyns88"
        />
        <MemberComponent
          img={Mingming}
          webpImg={MingmingWebP}
          name="Mingming"
          position="Community manager"
          twitterLink="https://x.com/mingming_Monad"
        />
        <MemberComponent
          img={Kaybu}
          webpImg={KaybuWebP}
          name="Kaybu"
          position="Community manager"
          twitterLink="https://x.com/0xkaybu"
        />
        <MemberComponent
          img={LK}
          webpImg={LKWebP}
          name="LK"
          position="Collab manager"
          twitterLink="https://x.com/LK_328"
        />
        <MemberComponent
          img={Picano}
          webpImg={PicanoWebP}
          name="Picano"
          position="Artist"
          twitterLink="https://x.com/Pican0_o"
        />
        <MemberComponent
          img={Mido}
          webpImg={MidoWebP}
          name="Mido"
          position="Artist"
          twitterLink="https://x.com/Mido_269"
        />
        <MemberComponent
          img={JN}
          webpImg={JNWebP}
          name="JN"
          position="Artist"
          twitterLink="https://x.com/JN_Jeannieeee"
        />
        <MemberComponent
          img={Nomad}
          webpImg={NomadWebP}
          name="Nomad"
          position="Dev"
          twitterLink="https://x.com/cryptofash34791"
        />
      </Container>
    </Section>
  );
};

export default Team;
